"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactstrap = require("reactstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ModalDialog(props) {
  const {
    isOpen,
    headerText,
    bodyText,
    buttonSecOnClick,
    buttonSecText,
    buttonPrimOnClick,
    buttonPrimText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Modal, {
    isOpen: isOpen
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.ModalHeader, null, headerText), /*#__PURE__*/_react.default.createElement(_reactstrap.ModalBody, null, bodyText), /*#__PURE__*/_react.default.createElement(_reactstrap.ModalFooter, null, buttonSecOnClick && buttonSecText && /*#__PURE__*/_react.default.createElement("button", {
    className: 'btn btn-secondary',
    onClick: buttonSecOnClick
  }, buttonSecText), /*#__PURE__*/_react.default.createElement("button", {
    className: 'btn btn-primary',
    onClick: buttonPrimOnClick
  }, buttonPrimText)));
}
var _default = exports.default = ModalDialog;
module.exports = exports.default;